import { firebaseFunctions } from '../../../../../firebase/firebase';
import { FirebaseCallableFunctions } from '../../../../../firebase/firebase.models';

interface RequestMObywatelVerificationParams {
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
}

export const showMObywatelInstructions = async (
  params: RequestMObywatelVerificationParams
): Promise<{ status: string; requestId: string }> => {
  const onShowMObywatelInstructions = firebaseFunctions.httpsCallable(
    FirebaseCallableFunctions.ON_SHOW_MOBYWATEL_INSTRUCTIONS
  );
  const result = await onShowMObywatelInstructions(params);
  return result.data;
};

export const requestMObywatelVerification = async (
  params: RequestMObywatelVerificationParams
): Promise<{ status: string; requestId: string }> => {
  const onRequestMObywatelVerification = firebaseFunctions.httpsCallable(
    FirebaseCallableFunctions.ON_REQUEST_MOBYWATEL_VERIFICATION
  );
  const result = await onRequestMObywatelVerification(params);
  return result.data;
};

export const updateMObywatelCode = async (requestId: string, verificationCode: string): Promise<{ status: string }> => {
  const updateMObywatelCode = firebaseFunctions.httpsCallable(FirebaseCallableFunctions.UPDATE_MOBYWATEL_CODE);
  const result = await updateMObywatelCode({ requestId, verificationCode });
  return result.data;
};

export const confirmMObywatelVerification = async (
  requestId: string,
  accepted: boolean,
  rejectionReason?: string,
  customRejectionMessage?: string
): Promise<{ status: string }> => {
  const confirmMObywatelVerification = firebaseFunctions.httpsCallable(
    FirebaseCallableFunctions.CONFIRM_MOBYWATEL_VERIFICATION
  );
  const result = await confirmMObywatelVerification({
    requestId,
    accepted,
    rejectionReason,
    customRejectionMessage,
  });
  return result.data;
};

export const handleContinueVerification = async (
  userUid: string,
  continueVerification: boolean
): Promise<{ status: string }> => {
  const handleContinueVerification = firebaseFunctions.httpsCallable(
    FirebaseCallableFunctions.HANDLE_CONTINUE_VERIFICATION
  );
  const result = await handleContinueVerification({ userUid, continueVerification });
  return result.data;
};

export const showUserModal = async (requestId: string): Promise<{ status: string }> => {
  const showUserModal = firebaseFunctions.httpsCallable(FirebaseCallableFunctions.SHOW_USER_MODAL);
  const result = await showUserModal({ requestId });
  return result.data;
};

export const resetVerification = async (requestId: string): Promise<{ status: string }> => {
  const resetVerification = firebaseFunctions.httpsCallable(FirebaseCallableFunctions.RESET_VERIFICATION);
  const result = await resetVerification({ requestId });
  return result.data;
};
